import Icon from '@material-ui/core/Icon';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { useMemo } from 'react';
import NexusNavBadge from '../../NexusNavBadge';

const useStyles = makeStyles((theme) => ({
  item: (props) => ({
    height: 40,
    width: '100%',
    borderRadius: '6px',
    margin: '0 0 4px 0',
    paddingRight: 12,
    paddingLeft: props.itemPadding > 80 ? 80 : props.itemPadding,
    '&.active': {
      backgroundColor: `${theme.palette.secondary.main}!important`,
      color: `${theme.palette.secondary.contrastText}!important`,
      pointerEvents: 'none',
      transition: 'border-radius .15s cubic-bezier(0.4,0.0,0.2,1)',
      '& .nexus-list-item-text-primary': {
        color: 'inherit',
      },
      '& .nexus-list-item-icon': {
        color: 'inherit',
      },
    },
    '& .nexus-list-item-icon': {
      marginRight: 12,
    },
    '& .nexus-list-item-text': {},
    color: theme.palette.text.primary,
    textDecoration: 'none!important',
  }),
}));

function NexusNavVerticalLink(props) {
  const { item, nestedLevel, onItemClick } = props;
  const classes = useStyles({
    itemPadding: nestedLevel > 0 ? 28 + nestedLevel * 16 : 12,
  });

  return useMemo(
    () => (
      <ListItem
        button
        component="a"
        href={item.url}
        target={item.target ? item.target : '_blank'}
        className={clsx(classes.item, 'nexus-list-item')}
        onClick={() => onItemClick && onItemClick(item)}
        role="button"
      >
        {item.icon && (
          <Icon
            className={clsx('nexus-list-item-icon text-20 flex-shrink-0', item.iconClass)}
            color="action"
          >
            {item.icon}
          </Icon>
        )}

        <ListItemText
          className="nexus-list-item-text"
          primary={item.title}
          classes={{ primary: 'text-16 nexus-list-item-text-primary' }}
        />

        {item.badge && <NexusNavBadge badge={item.badge} />}
      </ListItem>
    ),
    [classes.item, item, onItemClick]
  );
}

NexusNavVerticalLink.propTypes = {
  item: PropTypes.shape({
    id: PropTypes.string.isRequired,
    title: PropTypes.string,
    icon: PropTypes.string,
    url: PropTypes.string,
    target: PropTypes.string,
  }),
};
NexusNavVerticalLink.defaultProps = {};

const NavVerticalLink = NexusNavVerticalLink;

export default NavVerticalLink;
